import { Component, effect, OnDestroy, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { OrderWizardService } from "../../_service/order-wizard.service";
import { CorpCardComponent, CorpCheckboxComponent, CorpLoadingComponent, CorpTextareaComponent } from "@corporate-tailwind/component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'order-wizard-due-diligence',
    imports: [CommonModule, ReactiveFormsModule, CorpCheckboxComponent, CorpLoadingComponent, CorpCardComponent, TranslateModule],
    templateUrl: './order-wizard-due-diligence.component.html',
    styleUrls: ['./order-wizard-due-diligence.component.scss'],
    animations: [ ]
})
export class OrderWizardDueDiligenceComponent implements OnInit, OnDestroy {
    form: FormGroup | null = null;
    isSourceToTarget: boolean = true;
    activeLaser: number | null = null;

    constructor(
        public _orderWizardService: OrderWizardService,
    ) {
        this.form = this._orderWizardService.formGroup;

        effect(() => {
            const value = this._orderWizardService._state.orderWizard();
            if (!value) return;
            
            if(this._orderWizardService.isStepValidated(4)) {
                this._orderWizardService.enableControl(x=>x.step04?.dueDiligenceDto?.isInformationCertified);
                
            } else {
                this._orderWizardService.setValue(x=>x.step04?.dueDiligenceDto?.isInformationCertified, false);
                this._orderWizardService.disableControl(x=>x.step04?.dueDiligenceDto?.isInformationCertified);
            }
        });
    }

    ngOnInit(): void {
        
    }

    ngOnDestroy(): void {

    }

    isInformationCertifiedEnabled(): boolean {
        return this._orderWizardService.isStepValidated(4);
    }

    triggerLaser(index: number) {
        this.activeLaser = index;

        setTimeout(() => {
            this.activeLaser = null;
        }, 600); // durée animation
    }

}